export const GET_SERVICES = "GET_SERVICES";
export const GET_SERVICES_SUCCESS = "GET_SERVICES_SUCCESS";
export const GET_SERVICES_FAILURE = "GET_SERVICES_FAILURE";

// ===================================================
// ===================================================

export const GET_SINGLE_SERVICE = "GET_SINGLE_SERVICE";
export const GET_SINGLE_SERVICE_SUCCESS = "GET_SINGLE_SERVICE_SUCCESS";
export const GET_SINGLE_SERVICE_FAILURE = "GET_SINGLE_SERVICE_FAILURE";

// ===================================================
// ===================================================

export const CREATE_SERVICE = "CREATE_SERVICE";
export const CREATE_SERVICE_SUCCESS = "CREATE_SERVICE_SUCCESS";
export const CREATE_SERVICE_FAILURE = "CREATE_SERVICE_FAILURE";

// ===================================================
// ===================================================

export const UPDATE_SERVICE = "UPDATE_SERVICE";
export const UPDATE_SERVICE_SUCCESS = "UPDATE_SERVICE_SUCCESS";
export const UPDATE_SERVICE_FAILURE = "UPDATE_SERVICE_FAILURE";

// ===================================================
// ===================================================

export const DELETE_SERVICE = "DELETE_SERVICE";
export const DELETE_SERVICE_SUCCESS = "DELETE_SERVICE_SUCCESS";
export const DELETE_SERVICE_FAILURE = "DELETE_SERVICE_FAILURE";

// ===================================================
// ===================================================
